module.exports = __webpack_public_path__ + "img/CS-Small-Info.48b2ecf3.jpg";